import Amplify, { Auth } from 'aws-amplify';
import axios from 'axios';
import aws from 'aws-sdk';
import moment from 'moment';
import * as SecretKeys from '../ENV.json';
import { createTranscardAccount } from '../Actions/actions';

let JwtToken = localStorage.getItem('jwtToken');
if (JwtToken !== null) {
  JwtToken = JwtToken.slice(1, -1);
} else {
  JwtToken = '';
}
const userid = localStorage.getItem('userId');
const header = {
  /** 'Content-Type': 'application/json',* */
  'Application-Type': 'WEB',
  'Application-Token': 'WEB_6zJxK4AMDpahM3Yd7xARGPfRhcWbAkcY9dsfhu1sdF',
  'Session-Token': JwtToken || '',
  userId: userid || '',
};
axios.defaults.headers.common = header;

Amplify.configure(SecretKeys.awsUserpool);
const Api = SecretKeys.ApiUrl.ProdUrl;
const ApiE = SecretKeys.ApiUrl.ProdUrlE;
const ApiF = SecretKeys.ApiUrl.ProdUrlF;
const ApiG = SecretKeys.ApiUrl.ProdUrlG;
const ApiH = SecretKeys.ApiUrl.ProdUrlh;
const region = SecretKeys.awsUserpool.region;
const userPoolId = SecretKeys.awsUserpool.userPoolId;
const accessKeyId = SecretKeys.awsUserpool.accessKeyId;
const secretAccessKey = SecretKeys.awsUserpool.secretAccessKey;
const applicationUrl = SecretKeys.REACT_APP_FRONTEND_URL;
const fusebillApiUrl = SecretKeys.FUSEBILL.API_URL;
const fusebillKey = SecretKeys.FUSEBILL.KEY;

// Add a response interceptor

axios.interceptors.response.use(
  async (response) => {
    if (response.data.code === 401) {
      // console.log('comging in here??');
      // this.context.router.history.push('/');
      window.location.href = '/session-expired';
      await localStorage.clear();
      await Auth.signOut()
        .then(() => {
          // window.location.href = "/";
        })
        .catch((error) => error);
      return Promise.reject('error');
    }
    return response;
  },
  (error) =>
    /* localStorage.clear();
      Auth.signOut().then(() => {
          //this.context.router.history.push('/');
      }).catch((error) => error); */
    Promise.reject(error)
);

export const fetchData = async () => {
  try {
    const response = await fetch('https://randomuser.me/api');
    const data = await response.json();
    return data;
  } catch (e) {
    return e;
    // console.log(e);
  }
};
export const login = async (data) => {
  try {
    const response = await axios.post(`${Api}api/home/cognitoSavelogin`, data);
    // console.log('cognitoSavelogin response', response);
    if (response.data.code === 400) {
      return { code: 400, error: response.data.collectMessage.messageShort };
    }
    const secondData = { userId: response.data.result.userDto.userId };
    const config = {
      headers: {
        'Application-Type': 'WEB',
        'Application-Token': 'WEB_6zJxK4AMDpahM3Yd7xARGPfRhcWbAkcY9dsfhu1sdF',
        'Session-Token': response.data.result.userDto.token,
        userId: response.data.result.userDto.userId,
      },
    };
    const AccessInfo = await axios.post(
      `${Api}api/admin/getPlanByUserId`,
      secondData,
      config
    );
    // console.log('login AccessInfo',AccessInfo)
    localStorage.setItem(
      'jwtToken',
      JSON.stringify(response.data.result.userDto.token)
    );
    localStorage.setItem(
      'userId',
      JSON.stringify(response.data.result.userDto.userId)
    );
    localStorage.setItem(
      'email',
      response.data.result.userDto.email.toLowerCase()
    );
    localStorage.setItem(
      'acceptedDocument',
      response.data.result.userDto.acceptedDocument
    );
    localStorage.setItem(
      'affiliateUserId',
      JSON.stringify(response.data.result.userDto.affiliateUserId)
    );
    localStorage.setItem('roleName', response.data.result.userDto.roleName);
    localStorage.setItem(
      'userTypeFooter',
      response.data.result.userDto.roleName
    );
    localStorage.setItem(
      'signInCount',
      response.data.result.userDto.signInCount
    );
    localStorage.setItem(
      'VehiclesCancel',
      response.data.result.userDto.signInCount
    );
    if (
      response.data.result.userDto.readLetterOfAgency === 0 ||
      response.data.result.userDto.readPrivacyPolicy === 0 ||
      response.data.result.userDto.readUserAgreement === 0 ||
      response.data.result.userDto.readDisclaimer === 0 ||
      response.data.result.userDto.signatureImageFilePath === ''
    ) {
      localStorage.setItem('loginStatus', 'error');
    } else {
      localStorage.setItem('loginStatus', 'success');
    }
    // localStorage.setItem('paymentStatus', response.data.result.userDto.paymentStatus);
    localStorage.setItem('paymentStatus', 'paid');

    localStorage.setItem('firstName', response.data.result.userDto.firstName);
    localStorage.setItem('lastname', response.data.result.userDto.lastName);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('userObject', JSON.stringify(response.data.result));
    // localStorage.setItem('userAccessObject', JSON.stringify(response.data.result.planUserAccessLevelDtos)); need to change
    if (typeof AccessInfo.data.result !== 'undefined') {
      localStorage.setItem(
        'plainNameDto',
        AccessInfo.data.result.planDto.planName
      );
      localStorage.setItem(
        'userAccessObject',
        JSON.stringify(AccessInfo.data.result.planUserAccessLevelDtos)
      );
      localStorage.setItem(
        'userAccessObjectPlainName',
        JSON.stringify(AccessInfo.data.result.planDto)
      );
    }

    axios.defaults.headers.common['Session-Token'] =
      response.data.result.userDto.token;
    axios.defaults.headers.common.userId = response.data.result.userDto.userId;
    if (response.data.result.planDto && response.data.result.planDto.planName) {
      await localStorage.setItem(
        'planName',
        response.data.result.planDto.planName
      );
    }
    if (
      response.data.result.planPriceDtos &&
      response.data.result.planPriceDtos.fusebillPlanFrequencyId
    ) {
      await localStorage.setItem(
        'fusebillPlanFrequencyId',
        response.data.result.planPriceDtos.fusebillPlanFrequencyId
      );
    }
    if (
      response.data.result.userDto &&
      response.data.result.userDto.fusebillCustomerId
    ) {
      await localStorage.setItem(
        'fusebillCustomerId',
        response.data.result.userDto.fusebillCustomerId
      );
    }

    if (
      response.data.result.userDto &&
      response.data.result.userDto.fusebillAddressId
    ) {
      await localStorage.setItem(
        'fusebillBillingAddressId',
        response.data.result.userDto.fusebillAddressId
      );
    }
    await localStorage.setItem(
      'connectFusebill',
      response.data.result.planPriceDtos
        ? response.data.result.planPriceDtos.connectFusebill
        : 0
    );
    if (response.data.result.userDto.roleName === 'Business-User') {
      // if (response.data.result.planPriceDtos.connectFusebill === 0) {
      //   await localStorage.setItem('paymentStatus', 'paid');
      // } else {
      await localStorage.setItem(
          'paymentStatus',
          response.data.result.userDto.paymentStatus
      );
      // }
    }
    return {
      code: 200,
      user: data.user,
      userId: response.data.result.userDto.userId,
      roleName: response.data.result.userDto.roleName,
      userObject: response.data.result,
      affiliateKey: response.data.result.userDto.affiliateKey,
    };
  } catch (e) {
    return { code: 400, error: e };
  }
};

function updateUser(params) {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;
  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

  return new Promise((resolve, reject) => {
    try {
      cognitoidentityserviceprovider.adminUpdateUserAttributes(
        params,
        (err, data) => {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        }
      );
    } catch (e) {
      return { code: 400 };
    }
    return true;
  });
}
export const saveUploadEligibilityQuestionFileByUser = async (postData) => {
  console.log("postdata",postData)
  // const url = postData.image;
  // fetch(url)
  //   .then((res) => res.blob())
  //   .then((blob) => {
    // try {
    //   const data = info.data;
    //   const response = await axios.post(
    //     `${ApiF}api/settlement/getSettlementById`,
    //     data
    //   );
    //   if (response.code === 401) {
    //     return { code: 400 };
    //   }
    //   return response.data.result;
    // } catch (e) {
    //   return { code: 400 };
    // }
    try{
      const formdata = new FormData();
      formdata.append('settlementId', postData.settlementId);
      formdata.append('fileType', postData.fileType);
      formdata.append('fileName', postData.fileName);
      formdata.append('userId', localStorage.getItem('userId'));
      formdata.append('eligibilityQuestionId', postData.eligibilityQuestionId);
      formdata.append('file', postData.file);
  

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      const response = await axios.post(`${ApiF}api/settlement/uploadEligibilityQuestionFileByUser`, formdata, config)  ; 
      // if (response.code === 401) {
      //   return { code: 400 };
      // }
      return response.data.result;
    } catch (e) {
      return { code: 400 };
    }
  }

  export const saveDeleteUploadEligibilityQuestionFileByUser = async (postData) => {
    console.log("postdatass",postData)
    
      try {
        // const data = info.data;
        const response = await axios.post(
          `${ApiF}api/settlement/deleteEligibilityQuestionFileByUser`,
          postData
        );
        if (response.code === 401) {
          return { code: 400 };
        }
        return response.data.result;
      } catch (e) {
        return { code: 400 };
      }
      // try{
      //   const formdata = new FormData();
      //   formdata.append('settlementId', postData.settlementId);
      //   formdata.append('fileType', postData.fileType);
      //   formdata.append('fileName', postData.fileName);
      //   formdata.append('userId', localStorage.getItem('userId'));
      //   formdata.append('eligibilityQuestionId', postData.eligibilityQuestionId);
      //   formdata.append('file', postData.file);
    
  
      //   const config = {
      //     headers: {
      //       'content-type': 'multipart/form-data',
      //     },
      //   };
  
      //   const response = await axios.post(`${ApiF}api/settlement/uploadEligibilityQuestionFileByUser`, formdata, config)  ; 
      //   // if (response.code === 401) {
      //   //   return { code: 400 };
      //   // }
      //   return response.data.result;
      // } catch (e) {
      //   return { code: 400 };
      // }
    }
  
export const saveUploadFile = async (postData) => {
  const url = postData.image;
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const formdata = new FormData();
      formdata.append('signatureImageContentType', 'png');
      formdata.append('signatureImageFileSize', blob.size);
      formdata.append('file', blob, blob.name);
      formdata.append('userId', localStorage.getItem('userId'));
      formdata.append('firstName', postData.firstName);
      formdata.append('lastName', postData.lastName);
      formdata.append('email', postData.email);
      formdata.append('streeAddress', postData.streeAddress);

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      axios
        .post(`${Api}api/user/updateUserSignatureWithDocs`, formdata, config)
        .then(
          (res) =>
            // console.log('response',res);
            res.data
        )
        .catch((error) => error);
    });
};

export const updateUserSignatureWithDocsApi = async (postData) => {
  const url = postData.file;
  try {
    return await fetch(url)
      .then((res) => res.blob())
      .then(async (blob) => {
        const formdata = new FormData();
        // let blob = dataURItoBlob(data.file);
        formdata.append('signatureImageContentType', 'png');
        formdata.append('firstName', postData.firstNameFormData);
        formdata.append('lastName', postData.lastNameFormData);
        formdata.append('email', postData.emailFormData);
        formdata.append('signatureImageFileSize', blob.size);
        formdata.append('file', blob, blob.name);
        formdata.append('userId', localStorage.getItem('userId'));
        formdata.append('streeAddress', postData.streeAddressFomData);
        // formdata.append("file", blob);
        const config = {
          headers: {
            'content-type': 'multipart/form-data',
          },
        };

        return axios
          .post(`${Api}api/user/updateUserSignatureWithDocs`, formdata, config)
          .then(async (res) => {
            if (res.data.code === 200) {
              await localStorage.setItem("loginStatus", "success");
            }
            return res.data
          })
          .catch(error => error);
      });
  } catch (e) {
    return e;
  }
};

export const businessUserSignUp = async (postData) => {
  const data = postData;
  const url = data.file;
  let totalAmount;

  if (data.durationData === '1 Month') {
    totalAmount =
      parseFloat(
        data.selectedPlanAmount !== ''
          ? data.selectedPlanAmount.toFixed(2)
          : 0.0
      ) +
      parseFloat(
        data.enterpriseType === 'S'
          ? data.totalTaxId < 250
            ? data.totalTaxId
            : 250
          : 0
      );
  } else {
    totalAmount = (
      parseFloat(
        data.selectedPlanAmount !== ''
          ? data.selectedPlanAmount.toFixed(2)
          : 0.0
      ) +
      parseFloat(
        data.enterpriseType === 'S'
          ? data.totalTaxId < 250
            ? data.totalTaxId * data.durationCheckout * data.discountCheckout
            : 250 * data.durationCheckout * data.discountCheckout
          : 0.0
      )
    ).toFixed(2);
  }

  return fetch(url)
    .then((res) => res.blob())
    .then(async (blob) => {
      const info = {
        username: data.email.toLowerCase(),
        password: data.password,
        attributes: {
          email: data.email.toLowerCase(),
          phone_number:
            data.countryCode + data.nonWorkPhoneNumber.replace(/\s/g, ''),
          'custom:first_name': data.firstName.toString(),
          'custom:last_name': data.lastName.toString(),
          'custom:title': data.companyTitle.toString(),
          'custom:workphonenumber': (
            data.workCountryCode + data.workPhoneNumber
          )
            .toString()
            .replace(/\s/g, ''),
          'custom:employer': data.companyName.toString(),
          'custom:state': data.state.toString(),
          'custom:since': data.startingYear.toString(),
          'custom:roleName': data.roleName.toString(),
          'custom:streeAddress': data.streeAddress.toString(),
          'custom:city': data.cityId.toString(),
          'custom:zipCode': data.zipCode.toString(),
          'custom:separateTaxId': data.separateTaxId.toString(),
          'custom:webSite': data.webSite.toString(),
          'custom:taxId': data.taxId.toString(),
          'custom:bankruptcyStatus': data.bankruptcyStatus.toString(),
          'custom:dissolvedStatus': data.dissolvedStatus.toString(),
          'custom:acceptCC': data.acceptCC.toString(),
          'custom:planId': data.planPriceId.toString(),
          'custom:businessTypeId': '1',
          'custom:industryTypeId': data.industryTypeId.toString(),
          'custom:totalTaxId': data.totalTaxId.toString(),
          'custom:readDisclaimer': data.readDisclaimer.toString(),
          'custom:readPrivacyPolicy': data.readPrivacyPolicy.toString(),
          'custom:readLetterOfAgency': data.readLetterOfAgency.toString(),
          'custom:readUserAgreement': data.readUserAgreement.toString(),
        },
      };
      return Auth.signUp(info)
        .then(async (response) => {
          aws.config.accessKeyId = accessKeyId;
          aws.config.secretAccessKey = secretAccessKey;
          aws.config.region = region;
          const params = {
            UserPoolId: userPoolId,
            Username: data.email.toLowerCase(),
          };
          const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

          await cognitoidentityserviceprovider.adminConfirmSignUp(
            params,
            () => {}
          );
          params.UserAttributes = [
            {
              Name: 'email_verified',
              Value: 'true',
            },
          ];
          await updateUser(params);
          const formdata = new FormData();
          formdata.append('firstName', data.firstName);
          formdata.append('lastName', data.lastName);
          formdata.append('password', data.password);
          formdata.append('companyTitle', data.companyTitle);
          formdata.append(
            'mobilePhone',
            data.nonWorkPhoneNumber.replace(/\s/g, '')
          );
          formdata.append(
            'workPhoneNumber',
            data.workPhoneNumber.replace(/\s/g, '')
          );
          formdata.append('countryCode', data.countryCode);
          formdata.append('email', data.email.toLowerCase());
          formdata.append('companyName', data.companyName);
          formdata.append('streeAddress', data.streeAddress);
          formdata.append('city', data.city);
          formdata.append('stateId', data.state);
          formdata.append('zipCode', data.zipCode);
          formdata.append('separateTaxId', data.separateTaxId);
          formdata.append('enterpriseType', data.enterpriseType);
          formdata.append('startingYear', data.startingYear);
          formdata.append('webSite', data.webSite);
          formdata.append('taxId', data.taxId);
          formdata.append('affiliateId', data.affiliateId);
          // formdata.append("cognitoClientId",data.enterpriseType);
          formdata.append("bankruptcyStatus", data.bankruptcyStatus);
          formdata.append("dissolvedStatus", data.dissolvedStatus);
          formdata.append("acceptCC", data.acceptCC);
          formdata.append("planPriceId", data.planPriceId);
          formdata.append("businessTypeId", 1);
          formdata.append("industryTypeId", data.industryTypeId);
          formdata.append("otherIndustryType", data.otherIndustryType);

          formdata.append("totalTaxId", data.totalTaxId);
          formdata.append("roleName", data.roleName);
          formdata.append("readDisclaimer", data.readDisclaimer);
          formdata.append("readPrivacyPolicy", data.readPrivacyPolicy);
          formdata.append("readLetterOfAgency", data.readLetterOfAgency);
          formdata.append("readUserAgreement", data.readUserAgreement);
          formdata.append("signatureImageContentType", "png");
          formdata.append("signatureImageFileSize", blob.size);
          formdata.append("file", blob, blob.name);
          formdata.append("workCountryCode", data.workCountryCode);
          formdata.append("cognitoClientId", response.userSub);
          formdata.append("affiliateKey", data.affiliateKeyId);
          formdata.append("paymentStatus", data.paymentStatus);
          formdata.append("selectedPlanAmount", data.selectedPlanAmount);
          formdata.append("selectedPlanName", data.selectedPlanName);
          formdata.append("totalAmount", totalAmount);
          formdata.append('hearAboutUs', data.hearAboutUs);
          // formdata.append("file", blob); workCountryCode
          const config = {
            headers: {
              'content-type': 'multipart/form-data',
            },
          };
          // if()

          return axios
            .post(`${Api}api/business/saveBusinessUser`, formdata, config)
            .then((res) => {
              //    const dataChangePlain = {
              //   paymentStatus:	'pending',
              //   planPriceId:	data.planPriceId,
              //   selectedPlanAmount:	data.selectedPlanAmount,
              //   selectedPlanName: 	data.planName,
              //   userId:	res.data.result.userId,
              // }
              // axios.post(`${Api}api/home/planPriceChange`, dataChangePlain);

              //   console.log('saveBusinessUser api res', res);
              return res.data;
            })
            .catch((error) => error);
          // console.log('saveBusinessUser api response', response1);
        })
        .catch((error) => error);
    });
};

export const businessUserSignUpPartner = async (postData) => {
  // console.log('postData partner', postData)
  const data = postData;
  const url = data.file;

  let totalAmount;
  if (data.durationData === '1 Month') {
    totalAmount =
      parseFloat(
        data.selectedPlanAmount !== ''
          ? data.selectedPlanAmount.toFixed(2)
          : 0.0
      ) +
      parseFloat(
        data.enterpriseType === 'S'
          ? data.totalTaxId < 250
            ? data.totalTaxId
            : 250
          : 0
      );
  } else {
    totalAmount = (
      parseFloat(
        data.selectedPlanAmount !== ''
          ? data.selectedPlanAmount.toFixed(2)
          : 0.0
      ) +
      parseFloat(
        data.enterpriseType === 'S'
          ? data.totalTaxId < 250
            ? data.totalTaxId * data.durationCheckout * data.discountCheckout
            : 250 * data.durationCheckout * data.discountCheckout
          : 0.0
      )
    ).toFixed(2);
  }
  return fetch(url)
    .then((res) => res.blob())
    .then(async (blob) => {
      const info = {
        username: data.email.toLowerCase(),
        password: data.password,
        attributes: {
          email: data.email.toLowerCase(),
          phone_number:
            data.countryCode + data.nonWorkPhoneNumber.replace(/\s/g, ''),
          'custom:first_name': data.firstName.toString(),
          'custom:last_name': data.lastName.toString(),
          'custom:title': data.companyTitle.toString(),
          'custom:workphonenumber': (
            data.workCountryCode + data.workPhoneNumber
          )
            .toString()
            .replace(/\s/g, ''),
          'custom:employer': data.companyName.toString(),
          'custom:state': data.state.toString(),
          'custom:since': data.startingYear.toString(),
          'custom:roleName': data.roleName.toString(),
          'custom:streeAddress': data.streeAddress.toString(),
          'custom:city': data.cityId.toString(),
          'custom:zipCode': data.zipCode.toString(),
          'custom:separateTaxId': data.separateTaxId.toString(),
          'custom:webSite': data.webSite.toString(),
          'custom:taxId': data.taxId.toString(),
          'custom:bankruptcyStatus': data.bankruptcyStatus.toString(),
          'custom:dissolvedStatus': data.dissolvedStatus.toString(),
          'custom:acceptCC': data.acceptCC.toString(),
          'custom:planId': data.planPriceId.toString(),
          'custom:businessTypeId': '1',
          'custom:industryTypeId': data.industryTypeId.toString(),
          'custom:totalTaxId': data.totalTaxId.toString(),
          'custom:readDisclaimer': data.readDisclaimer.toString(),
          'custom:readPrivacyPolicy': data.readPrivacyPolicy.toString(),
          'custom:readLetterOfAgency': data.readLetterOfAgency.toString(),
          'custom:readUserAgreement': data.readUserAgreement.toString(),
        },
      };
      return Auth.signUp(info)
        .then(async (response) => {
          aws.config.accessKeyId = accessKeyId;
          aws.config.secretAccessKey = secretAccessKey;
          aws.config.region = region;
          const params = {
            UserPoolId: userPoolId,
            Username: data.email.toLowerCase(),
          };
          const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

          await cognitoidentityserviceprovider.adminConfirmSignUp(
            params,
            () => {}
          );
          params.UserAttributes = [
            {
              Name: 'email_verified',
              Value: 'true',
            },
          ];
          await updateUser(params);
          const formdata = new FormData();
          formdata.append('firstName', data.firstName);
          formdata.append('lastName', data.lastName);
          formdata.append('password', data.password);
          formdata.append('companyTitle', data.companyTitle);
          formdata.append(
            'mobilePhone',
            data.nonWorkPhoneNumber.replace(/\s/g, '')
          );
          formdata.append(
            'workPhoneNumber',
            data.workPhoneNumber.replace(/\s/g, '')
          );
          formdata.append('countryCode', data.countryCode);
          formdata.append('email', data.email.toLowerCase());
          formdata.append('companyName', data.companyName);
          formdata.append('streeAddress', data.streeAddress);
          formdata.append('streetAddress2', data.streeAddress2);

          formdata.append('city', data.city);
          formdata.append('stateId', data.state);
          formdata.append('zipCode', data.zipCode);
          formdata.append('separateTaxId', data.separateTaxId);
          formdata.append('enterpriseType', data.enterpriseType);
          formdata.append('startingYear', data.startingYear);
          formdata.append('webSite', data.webSite);
          formdata.append('taxId', data.taxId);
          formdata.append('affiliateId', data.affiliateId);
          // formdata.append("cognitoClientId",data.enterpriseType);
          formdata.append("bankruptcyStatus", data.bankruptcyStatus);
          formdata.append("dissolvedStatus", data.dissolvedStatus);
          formdata.append("acceptCC", data.acceptCC);
          formdata.append("planPriceId", data.planPriceId);
          formdata.append("businessTypeId", 1);
          formdata.append("industryTypeId", data.industryTypeId);
          formdata.append("otherIndustryType", data.otherIndustryType);

          formdata.append("totalTaxId", data.totalTaxId);
          formdata.append("roleName", data.roleName);
          formdata.append("readDisclaimer", data.readDisclaimer);
          formdata.append("readPrivacyPolicy", data.readPrivacyPolicy);
          formdata.append("readLetterOfAgency", data.readLetterOfAgency);
          formdata.append("readUserAgreement", data.readUserAgreement);
          formdata.append("signatureImageContentType", "png");
          formdata.append("signatureImageFileSize", blob.size);
          formdata.append("file", blob, blob.name);
          formdata.append("workCountryCode", data.workCountryCode);
          formdata.append("cognitoClientId", response.userSub);
          formdata.append("affiliateKey", data.affiliateKeyId);
          formdata.append("paymentStatus", data.paymentStatus);
          formdata.append("selectedPlanAmount", data.selectedPlanAmount);
          formdata.append("selectedPlanName", data.selectedPlanName);
          formdata.append("totalAmount", totalAmount);
          formdata.append('hearAboutUs', data.hearAboutUs);
          // formdata.append("file", blob); workCountryCode
          const config = {
            headers: {
              'content-type': 'multipart/form-data',
            },
          };
          // console.log('ssssssssssssssss', data)
          // if()

          return axios
            .post(`${Api}api/business/saveBusinessUser`, formdata, config)
            .then((res) => {
              //    const dataChangePlain = {
              //   paymentStatus:	'pending',
              //   planPriceId:	data.planPriceId,
              //   selectedPlanAmount:	data.selectedPlanAmount,
              //   selectedPlanName: 	data.planName,
              //   userId:	res.data.result.userId,
              // }
              // axios.post(`${Api}api/home/planPriceChange`, dataChangePlain);

              //   console.log('saveBusinessUser api res', res);
              return res.data;
            })
            .catch((error) => error);
          // console.log('saveBusinessUser api response', response1);
        })
        .catch((error) => error);
    });
};

// update Business

export const updateBusinessUser = async (postData) => {
  console.log('updateBusinessUser', postData);

  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;

  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

  const params = {
    UserPoolId: userPoolId,
    Username: postData.cognitoClientId,
    UserAttributes: [
      {
        Name: 'email',
        Value: postData.email.toLowerCase(),
      },
      {
        Name: 'phone_number',
        Value: postData.countryCode + postData.mobilePhone.replace(/\s/g, ''),
      },
      {
        Name: 'custom:first_name',
        Value: postData.firstName.toString(),
      },
      {
        Name: 'custom:last_name',
        Value: postData.lastName.toString(),
      },
      {
        Name: 'custom:state',
        Value: postData.state.toString(),
      },
      {
        Name: 'custom:workphonenumber',
        Value: postData.workPhoneNumber.toString().replace(/\s/g, ''),
      },
      {
        Name: 'custom:title',
        Value: postData.companyTitle.toString(),
      },
      {
        Name: 'custom:streeAddress',
        Value: postData.streeAddress.toString(),
      },
      {
        Name: 'custom:since',
        Value: postData.startingYear.toString(),
      },
      {
        Name: 'custom:city',
        Value: postData.city.toString(),
      },
      {
        Name: 'custom:zipCode',
        Value: postData.zipCode.toString(),
      },
      {
        Name: 'custom:separateTaxId',
        Value: postData.separateTaxId.toString(),
      },
      {
        Name: 'custom:webSite',
        Value: postData.webSite.toString(),
      },
      {
        Name: 'custom:taxId',
        Value: postData.taxId.toString(),
      },
      {
        Name: 'custom:bankruptcyStatus',
        Value: postData.bankruptcyStatus.toString(),
      },
      {
        Name: 'custom:dissolvedStatus',
        Value: postData.dissolvedStatus.toString(),
      },
      {
        Name: 'custom:acceptCC',
        Value: postData.acceptCC.toString(),
      },
    ],
  };

  cognitoidentityserviceprovider.adminUpdateUserAttributes(
    params,
    async (err) => {
      if (err) {
        // empty
      } else {
        params.UserAttributes = [
          {
            Name: 'email_verified',
            Value: 'true',
          },
        ];
        cognitoidentityserviceprovider.adminUpdateUserAttributes(
          params,
          (err1) => {
            if (err1) {
              // empty
            }
          }
        );
        const dataBussness = {
          userId: postData.userId,
          firstName: postData.firstName,
          lastName: postData.lastName,
          companyTitle: postData.companyTitle,
          mobilePhone: postData.mobilePhone.replace(/\s/g, ''),
          workPhoneNumber: postData.workPhoneNumber.replace(/\s/g, ''),
          email: postData.email.toLowerCase(),
          companyName: postData.companyName,
          streeAddress: postData.streeAddress,
          city: postData.city,
          stateId: postData.state,
          zipCode: postData.zipCode,
          separateTaxId: postData.separateTaxId,
          enterpriseType: postData.enterpriseType,
          startingYear: postData.startingYear,
          webSite: postData.webSite,
          taxId: postData.taxId,
          bankruptcyStatus: postData.bankruptcyStatus,
          dissolvedStatus: postData.dissolvedStatus,
          acceptCC: postData.acceptCC,
          businessTypeId: 1,
          industryTypeId: postData.industryTypeId,
          totalTaxId: postData.totalTaxId,
          countryCode: postData.countryCode,
          workCountryCode: postData.workCountryCode,
          readDisclaimer: postData.readDisclaimer,
          readPrivacyPolicy: postData.readPrivacyPolicy,
          readLetterOfAgency: postData.readLetterOfAgency,
          readUserAgreement: postData.readUserAgreement,
          planPriceId: postData.planPriceId,
          otherIndustryType: postData.otherIndustryType,
          streetAddress2: postData.streeAddress2,
        };

        localStorage.setItem('firstName', postData.firstName);
        localStorage.setItem('lastname', postData.lastName);

        console.log('dataBussness', dataBussness);

        // Get the Details of the user.
        // const user = { userId: postData.userId };
        // const userResponse = await axios.post(`${Api}api/business/getBusinessUser`, user);
        // const selectedPlanName = userResponse.data.result.selectedPlanName;
        // const fusebillCustomerId = userResponse.data.result.fusebillCustomerId;

        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Basic ${fusebillKey}`,
          },
        };

        // if (selectedPlanName !== 'Basic'
        //   && selectedPlanName !== 'Basic Outsourced'
        //   && fusebillCustomerId) {
        // Fusebill customer update----------
        if (localStorage.getItem('fusebillCustomerId')) {
          const customerInfo = {
            id: localStorage.getItem('fusebillCustomerId'),
            firstName: postData.firstName,
            lastName: postData.lastName,
            companyName: postData.companyName,
            Status: 'Active',
            primaryEmail: postData.email.toLowerCase(),
          };
          await axios.put(`${fusebillApiUrl}customers`, customerInfo, config);
        }
        // Fusebill Billing address update-----
        if (localStorage.getItem('fusebillBillingAddressId')) {
          const billingAddress = {
            customerAddressPreferenceId: localStorage.getItem(
              'fusebillCustomerId'
            ),
            id: localStorage.getItem('fusebillBillingAddressId'),
            companyName: postData.companyName,
            line1: postData.streeAddress,
            line2: postData.streeAddress2,
            country: 'United States',
            state: postData.stateName,
            city: postData.city,
            postalZip: postData.zipCode,
            addressType: 'Billing',
          };
          await axios.put(`${fusebillApiUrl}Addresses`, billingAddress, config);
        }
        // }

        await axios
          .post(`${Api}api/business/updateBusinessProfile`, dataBussness)
          .then((res) => res.data)
          .catch((error) => error);
      }
    }
  );
};

export const fusebillCreateCustomerBasic = async (uData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };

    // Create Customer
    const response = await axios.post(
      `${fusebillApiUrl}customers`,
      uData.customerInfo,
      config
    );

    // Activate Customer
    const dataCustomer = {
      customerId: response.data.id,
      activateAllSubscriptions: true,
      activateAllDraftPurchases: true,
      temporarilyDisableAutoPost: false,
    };

    await axios.post(
      `${fusebillApiUrl}customerActivation`,
      dataCustomer,
      config
    );

    const billingAddress = {
      customerAddressPreferenceId: response.data.id,
      companyName: uData.billing.companyName,
      line1: uData.billing.line1,
      city: uData.billing.city,
      postalZip: uData.billing.postalZip,
      country: uData.billing.country,
      state: uData.billing.state,
      addressType: 'Billing',
    };

    const response2 = await axios.post(
      `${fusebillApiUrl}Addresses`,
      billingAddress,
      config
    );

    // Add fusebill customer ID to DB.
    const data2 = {
      userId: uData.customerInfo.userId,
      fusebillCustomerId: response.data.id,
      fusebillAddressId: response2.data.id,
    };
    await axios.post(
      `${Api}api/business/updateFusebillCustomerIdByUserId`,
      data2
    );
    await localStorage.setItem('paymentStatus', 'pending');
    localStorage.setItem('fusebillBillingAddressId', response2.data.id);

    return {
      fusebillCustomerId: response.data.id,
      fusebillBillingAddressId: response2.data.id,
    };
  } catch (e) {
    return { code: 400 };
  }
};



export const createTranscardAccountApi = (postData) => {
  let data
  if(!postData.data) {
     data = {
      userId: postData,
    }
  }
  if(postData.data) {
     data = {
      userId: postData.data.userId,
      streeAddress: postData.data.streeAddress,
      streetAddress2: postData.data.streetAddress2,
      city: postData.data.city,
      stateId: postData.data.stateId,
      zipCode: postData.data.zipCode,
    };
  }

  try {
    const response =  axios.post(
      `${Api}api/user/createTranscardAccount`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const createTranscardCardApi = (postData) => {
  let data
  if(!postData.data) {
     data = {
      userId: postData,
    }
  }
  if(postData.data) {
     data = {
      userId: postData.data.userId,
      streeAddress: postData.data.streeAddress,
      streetAddress2: postData.data.streetAddress2,
      city: postData.data.city,
      zipCode: postData.data.zipCode,
      stateId: postData.data.stateId,
    };
  }

  try {
    const response =  axios.post(
      `${Api}api/user/createTranscardAccount`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const setDefaultBankAccountApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    bankAccountId: postData.data.bankAccountId
  };

  try {
    const response =  axios.post(
      `${Api}api/user/setDefaultBankAccount`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const setDefaultCardApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    cardId: postData.data.cardId
  };

  try {
    const response =  axios.post(
      `${Api}api/user/setDefaultCard`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const addUserCardApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    cvc: postData.data.cvc,
    firstName: postData.data.firstName,
    lastName: postData.data.lastName,
    cardNickName: postData.data.cardNickName,
    cardNumber: postData.data.cardNumber,
    cardExpirationDate: postData.data.cardExpirationDate,
    streeAddress: postData.data.streeAddress,
    streetAddress2: postData.data.streetAddress2,
    city: postData.data.city,
    zipCode: postData.data.zipCode,
  };

  try {
    const response =  axios.post(
      `${Api}api/user/addUserCard`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const addBusinessUserCardApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    cvc: postData.data.cvc,
    firstName: postData.data.firstName,
    lastName: postData.data.lastName,
    cardNickName: postData.data.cardNickName,
    cardNumber: postData.data.cardNumber,
    cardExpirationDate: postData.data.cardExpirationDate,
  };

  try {
    const response =  axios.post(
      `${Api}api/user/addUserCard`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const deleteUserBankAccountApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    bankAccountId: postData.data.bankAccountId
  };

  try {
    const response =  axios.post(
      `${Api}api/user/deleteUserBankAccount`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const deleteUserCardApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    bankAccountId: postData.data.bankAccountId
  };

  try {
    const response =  axios.post(
      `${Api}api/user/deleteUserCard`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getAddedBankAccountsForUserApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      `${Api}api/user/getAddedBankAccountsForUser`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getAddedCardsForUserApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      `${Api}api/user/getAddedCardsForUser`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getAllBankAccountsForUserApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      `${Api}api/user/getAllBankAccountsForUser`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getAllAddedCardsForUserApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      `${Api}api/user/getAllAddedCardsForUser`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getCollectedSettlementsHistoryForUserApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      // `https://api-settlement-dev.collectively.app/api/settlement/getCollectedSettlementsHistoryForUser`,
      `${ApiF}api/settlement/getCollectedSettlementsHistoryForUser`, 
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const getUserTransactionsHistoryApi = (postData) => {
  const data = {
    userId: postData
  };

  try {
    const response =  axios.post(
      // `https://api-user-dev.collectively.app/api/user/getUserTransactionsHistory`,
      `${Api}api/user/getUserTransactionsHistory`, 
      data
    );
    
    return response;
  } catch (e) {
    return [];
  }

}

export const showNetAmountToUserApi = (postData) => {
  const data = {
    walletBalance: postData.data.walletBalance,
    transferMode: postData.data.transferMode
  };

  try {
    const response =  axios.post(
      `${Api}api/user/showNetAmountToUser`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}


export const getTranscardPaymentMethodsApi = async () => {
  try {
    const response = await axios.post(`${Api}api/user/getTranscardPaymentMethods`);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getDisbursePayment = async (postData) => {
  const data = {
    userId: postData.data.userId,
    debitedAmount: postData.data.debitedAmount,
    transferMode: postData.data.transferMode
  };

  try {
    const response = await axios.post(`${Api}api/user/immediatePaymentToTPaymentAccout`,data);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getTransferFundsToACH = async (postData) => {
  const data = {
    userId: postData.data.userId,
    paymentId: postData.data.paymentId,
    debitedAmount: postData.data.debitedAmount,
    transferMode: postData.data.transferMode
  };

  try {
    const response = await axios.post(`${Api}api/user/transferFundsToACH`,data);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getTransferFundsToCard = async (postData) => {
  const data = {
    userId: postData.data.userId,
    paymentId: postData.data.paymentId,
    debitedAmount: postData.data.debitedAmount,
    transferMode: postData.data.transferMode
  };

  try {
    const response = await axios.post(`${Api}api/user/transferFundsToCard`,data);
    return response.data;
  } catch (e) {
    return [];
  }
};

export const addUserBankAccountApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    name : postData.data.accountHolderName,
    accountNumber :  postData.data.accountNumber,
    routingNumber : postData.data.routingNumber,
    accountType : postData.data.accountType,
    accountDisplayName : postData.data.displayName
  };

  try {
    const response =  axios.post(
      `${Api}api/user/addUserBankAccount`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const updateBankAccountDetailsApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    bankAccountId : postData.data.bankAccountId,
    accountDisplayName :  postData.data.accountDisplayName,
  };

  try {
    const response =  axios.post(
      `${Api}api/user/updateBankAccountDetails`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

export const updateCardDetailsApi = (postData) => {
  const data = {
    userId: postData.data.userId,
    cardId : postData.data.cardId,
    cardNickName :  postData.data.cardNickName,
  };

  try {
    const response =  axios.post(
      `${Api}api/user/updateCardDetails`,
      data
    );
    return response;
  } catch (e) {
    return [];
  }

}

// update consumer
export const updateConsumerUser = async (postData) => {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;

  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

  const params = {
    UserPoolId: userPoolId,
    Username: postData.cognitoClientId,
    UserAttributes: [
      {
        Name: 'email',
        Value: postData.cEmail.toLowerCase(),
      },
      {
        Name: 'phone_number',
        Value: postData.cCountryCode + postData.cPhone.replace(/\s/g, ''),
      },
      {
        Name: 'custom:first_name',
        Value: postData.cFirstName.toString(),
      },
      {
        Name: 'custom:last_name',
        Value: postData.cLastName.toString(),
      },
      {
        Name: 'custom:employer',
        Value: postData.cEmployer.toString(),
      },
    ],
  };
  cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err) => {
    if (err) {
      return err;
    }

    return true;
  });
  params.UserAttributes = [
    {
      Name: 'email_verified',
      Value: 'true',
    },
  ];
  cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err) => {
    if (err) {
      // empty
    }
  });
  const data = {
    userId: postData.userId,
    firstName: postData.cFirstName,
    lastName: postData.cLastName,
    mobilePhone: postData.cPhone.replace(/\s/g, ''),
    planPriceId: postData.planPriceId,
    // "stateId":20,
    employer: postData.cEmployer,
    notifyByText: postData.cNotification,
    notifyProductUpdates: postData.cUpdateClaim,
    // "beginYear":2015,
    readDisclaimer: postData.readDisclaimer,
    readPrivacyPolicy: postData.readPrivacyPolicy,
    readLetterOfAgency: postData.readLetterOfAgency,
    readUserAgreement: postData.readUserAgreement,
    email: postData.cEmail,
    roleName: postData.roleName,
    countryCode: postData.cCountryCode,
  };

  try {
    const response = await axios.post(
      `${Api}api/user/updateConsumerProfile`,
      data
    );
    localStorage.setItem('firstName', postData.cFirstName);
    localStorage.setItem('lastname', postData.cLastName);
    return response;
  } catch (e) {
    return [];
  }
};

// save consumer

export const saveConsumerUserSignUp = async (postData) => {
  const data = postData;
  const url = data.file;
  await fetch(url)
    .then((res) => res.blob())
    .then(async (blob) => {
      const info = {
        username: data.cEmail.toLowerCase(),
        password: data.cPassword,
        attributes: {
          email: data.cEmail.toLowerCase(),
          phone_number: data.countryCode + data.cPhone.replace(/\s/g, ''),
          'custom:first_name': data.cFirstName.toString(),
          'custom:last_name': data.cLastName.toString(),
          'custom:employer': data.cEmployer.toString(),
          'custom:state': data.cState.toString(),
          'custom:since': data.cSince.toString(),
          'custom:roleName': data.cRoleName.toString(),
          'custom:readDisclaimer': data.readDisclaimer.toString(),
          'custom:readPrivacyPolicy': data.readPrivacyPolicy.toString(),
          'custom:readLetterOfAgency': data.readLetterOfAgency.toString(),
          'custom:readUserAgreement': data.readUserAgreement.toString(),
        },
      };

      await Auth.signUp(info)
        .then(async (response) => {
          aws.config.accessKeyId = accessKeyId;
          aws.config.secretAccessKey = secretAccessKey;
          aws.config.region = region;
          const params = {
            UserPoolId: userPoolId,
            Username: data.cEmail.toLowerCase(),
          };
          const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();
          await cognitoidentityserviceprovider.adminConfirmSignUp(
            params,
            () => {}
          );
          params.UserAttributes = [
            {
              Name: 'email_verified',
              Value: 'true',
            },
          ];
          await updateUser(params);

          /* Auth.confirmSignUp(this.state.email, this.state.confirmationCode).then((res)=>{

            }) */
          const formdata = new FormData();
          formdata.append('firstName', data.cFirstName);
          formdata.append('lastName', data.cLastName);
          formdata.append('password', data.cPassword);
          formdata.append('mobilePhone', data.cPhone.replace(/\s/g, ''));
          // formdata.append('planPriceId', 23);
          formdata.append('planPriceId', data.consumerPlanPriceId);
          formdata.append('email', data.cEmail.toLowerCase());
          if (data.caffiliateId) {
            formdata.append('affiliateId', data.caffiliateId);
            formdata.append('affiliateKey', data.caffiliateKey);
          }
          if (data.affiliateId) {
            formdata.append('affiliateKey', data.affiliateKeyId);
            formdata.append('affiliateId', data.affiliateId);
          }
          formdata.append('stateId', data.cState);
          formdata.append('bankAccount', data.bankAccount);
          formdata.append('employer', data.cEmployer);
          formdata.append('roleName', data.cRoleName);
          formdata.append(
            'notifyByText',
            data.cNotification !== '' ? '1' : '0'
          );
          formdata.append('notifyProductUpdates', data.cUpdateClaim);
          formdata.append('beginYear', data.cSince);
          formdata.append('readDisclaimer', data.readDisclaimer);
          formdata.append('readPrivacyPolicy', data.readPrivacyPolicy);
          formdata.append('readLetterOfAgency', data.readLetterOfAgency);
          formdata.append('readUserAgreement', data.readUserAgreement);
          formdata.append('signatureImageContentType', 'png');
          formdata.append('signatureImageFileSize', blob.size);
          formdata.append('file', blob, blob.name);
          formdata.append('cognitoClientId', response.userSub);
          formdata.append('countryCode', data.countryCode);
          formdata.append('applicationUrl', applicationUrl);
          formdata.append('hearAboutUs', data.hearAboutUs);
          const config = {
            headers: {
              'content-type': 'multipart/form-data',
            },
          };

          await axios
            .post(`${Api}api/user/saveConsumerUser`, formdata, config)
            .then((res) => res.data)
            .catch((error) => error);
        })
        .catch((error) => error);
    })
    .catch((error) => {
      console.log('error', error);
    });
};

export const getAllCountryData = async () => {
  try {
    const response = await axios.get(`${Api}api/home/getAllCountry`);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getAllStates = async () => {
  try {
    const response = await axios.get(`${Api}api/home/getAllStates`);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

// getAllSitePagesData
export const getAllSitePagesData = async () => {
  try {
    const response = await axios.get(`${ApiE}api/content/getAllSitePages`);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

// saveMultipleVehicleDataApi
export const saveMultipleVehicleDataApi = async (info) => {
  try {
    // let data={"sitePageId":info}
    const response = await axios.post(
      `${Api}api/user/saveMultipleVehicleData`,
      info.data
    );
    // const data = await response.json();
    return response.data.result;
  } catch (e) {
    return [];
  }
};

// changePasswordDataData

function updatePassword(params) {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;
  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

  return new Promise((resolve, reject) => {
    cognitoidentityserviceprovider.changePassword(params, (err, data) => {
      if (err) {
        reject(err.message);
      } else {
        resolve(data);
      }
    });
  });
}

export const changePasswordDataData = async (postData) => {
  // console.log("changePasswordDataData",postData)
  let JwtTokenACcess = localStorage.getItem('jwtToken');
  if (JwtTokenACcess !== null) {
    JwtTokenACcess = JwtTokenACcess.slice(1, -1);
  }
  // console.log("JwtToken", postData)
  //  aws.config.accessKeyId = accessKeyId;
  // aws.config.secretAccessKey = secretAccessKey;
  // aws.config.region = region;
  // let cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();
  const params = {
    AccessToken: JwtTokenACcess,
    PreviousPassword: postData.oldPassword,
    ProposedPassword: postData.password,
  };

  try {
    const responsePassword = await updatePassword(params);
    if (responsePassword === '') {
      return [];
    }
    if (responsePassword !== '') {
      const info = {
        email: postData.email.toLowerCase(),
        password: postData.password,
      };
      const response = await axios.post(`${Api}api/home/resetPassword`, info);
      return response;
    }

    return [];
  } catch (e) {
    return e;
  }
};
// getActivityLogData
export const getActivityLogData = async (info) => {
  try {
    const response = await axios.post(`${Api}api/home/getActivityLog`, info);
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// getAllVehicleYearData

export const getAllVehicleYearData = async () => {
  try {
    const response = await axios.get(`${Api}api/home/getAllVehicleYear`);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

// getAllVehicleYearData

export const getTotalFundSettlementData = async () => {
  try {
    const response = await axios.get(
      `${ApiF}api/settlement/getTotalFundSettlement`
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getAllVehicleMakeData = async (postData) => {
  try {
    const data = { vehicleYear: postData };
    const response = await axios.post(`${Api}api/home/getAllVehicleMake`, data);
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
// getAllVehicleModelData

export const getAllVehicleModelData = async (postData) => {
  try {
    const response = await axios.post(
      `${Api}api/home/getAllVehicleModel`,
      postData
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
// getAllVehicleTrimData

export const getAllVehicleTrimData = async (postData) => {
  try {
    const data = {
      vehicleYear: postData.data.vehicleYear,
      vehicleMake: postData.data.vehicleMake,
      vehicleModel: postData.data.vehicleModel,
    };
    const response = await axios.post(`${Api}api/home/getAllVehicleTrim`, data);
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
// getExternalVehicleDataByIdData
export const getExternalVehicleDataByIdData = async (postData) => {
  try {
    const data = {
      userId: postData.id,
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: '',
    };
    const response = await axios.post(
      `${Api}api/user/getExternalVehicleDataById`,
      data
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
// save data

export const saveVehicleData = async (postData) => {
  try {
    // console.log("save post data ",postData)
    const data = {
      vehicleYear: postData.data.yearId,
      vehicleMake: postData.data.makeId,
      vehicleModel: postData.data.modelId,
      userId: localStorage.getItem('userId'),
      trim: postData.data.trimId,
      vin: postData.data.vin,
      purchaseDate: moment(postData.data.startDate).format(
        'YYYY-MM-DD HH:MM:SS'
      ),
      soldDate: moment(postData.data.endDate).format('YYYY-MM-DD HH:MM:SS'),
      vehicleCost: postData.data.vehicleCostId,
      vehicleType: postData.data.vehicleTypeId,
    };
    const response = await axios.post(`${Api}api/user/saveVehicleData`, data);
    localStorage.setItem('VehiclesCancel', '2');
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

// save data

export const saveResidencesData = async (postData) => {
  try {
    // console.log("save post data ",postData)
    const data = {
      stateId: postData.rState,
      beginYear: postData.rSinceFrom,
      endYear: postData.rSinceTo,
      userId: localStorage.getItem('userId'),
      primaryFlag: postData.primaryFlag,
    };
    const response = await axios.post(`${Api}api/user/saveUserResidence`, data);
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getStateData = async (postData) => {
  try {
    const data = { countryId: postData };
    const response = await axios.post(
      `${Api}api/home/getStateByCountryId`,
      data
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// delete
export const deleteVehicleRecordsDataUser = async (postData) => {
  try {
    const data = {
      vehicleDataId: postData.id,
      userId: postData.userId,
    };
    const response = await axios.post(`${Api}api/user/deleteVehicleData`, data);
    return response.data.code;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllVehicleDataByUserIdData = async (postData) => {
  try {
    const data = {
      userId: postData,
      pageNumber: 0,
      pageSize: 20,
      searchKeyword: '',
    };
    const response = await axios.post(
      `${Api}api/user/getAllVehicleDataByUserId`,
      data
    );
    if (response.data.result.records !== undefined) {
      return response.data.result.records;
    }
  } catch (e) {
    return [];
  }
  return true;
};

export const getCityByStateIdData = async (postData) => {
  try {
    const data = { stateId: postData };
    const response = await axios.post(`${Api}api/home/getCityByStateId`, data);
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const deleteResidencesUserData = async (postData) => {
  try {
    console.log('postData', postData);
    const data = {
      userResidenceId: postData.data.addressID,
      userId: postData.data.userId,
    };
    const response = await axios.post(
      `${Api}api/user/deleteUserResidence`,
      data
    );
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const viewResidencesDataApi = async (postData) => {
  try {
    const data = {
      userResidenceId: postData.data.userResidenceId,
      beginYear: postData.data.rSinceFrom,
      endYear: postData.data.rSinceTo,
      stateId: postData.data.rState,
      primaryFlag: postData.data.primaryFlag,
      userId: postData.data.userId,
    };
    const response = await axios.post(
      `${Api}api/user/updateUserResidence`,
      data
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const viewVehicleEditRecordData = async (postData) => {
  // console.log("update data asdasd",postData.endDate)
  try {
    const data = {
      vehicleDataId: postData.vehicleId,
      vehicleYear: postData.yearId,
      vehicleMake: postData.makeId,
      vehicleModel: postData.modelId,
      userId: localStorage.getItem('userId'),
      trim: postData.trimId,
      vin: postData.vin,
      purchaseDate: moment(postData.startDate).format('YYYY-MM-DD HH:MM:SS'),
      soldDate: moment(postData.endDate).format('YYYY-MM-DD HH:MM:SS'),
      vehicleCost: postData.vehicleCostId,
      vehicleType: postData.vehicleTypeId,
      fromInfutor: postData.fromInfutor,
    };
    const response = await axios.post(`${Api}api/user/updateVehicleData`, data);
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getConsumerUserProfile = async (postData) => {
  try {
    const data = { userId: postData };
    const response = await axios.post(`${Api}api/user/getConsumerUser`, data);
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAutoUpdateUserApi = async (postData) => {
  try {
    const response = await axios.post(
      `${Api}api/user/updateAutoSettlementFlag`,
      postData
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAffiliateDataUser = async (postData) => {
  try {
    const data = { userId: postData };
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateUser`,
      data
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllChildCompanyProfileData = async (params) => {
  try {
    const response = await axios.post(
      `${Api}api/business/getAllChildCompanyProfile`,
      params
    );
    if (response.data.result === undefined) {
      return [];
    }
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getBusinessUserProfile = async (postData) => {
  try {
    const data = { userId: postData };
    const response = await axios.post(
      `${Api}api/business/getBusinessUser`,
      data
    );
    await localStorage.setItem(
      'selectedPlanAmount',
      response.data.result.selectedPlanAmount
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getNotificationLogUnReadCountForUserApi = async (postData) => {
  try {
    const response = await axios.post(
      `${Api}api/user/getNotificationLogUnReadCountForUser`,
      postData
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const markNotificationReadForUserApi = async (postData) => {
  try {
    const response = await axios.post(
      `${Api}api/user/markNotificationReadForUser`,
      postData
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const viewCompanyChildRecordSave = async (postData) => {
  try {
    const data = { childCompanyProfileId: postData };
    const response = await axios.post(
      `${Api}api/business/getChildCompanyProfileById`,
      data
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllPlansConsumer = async (postData) => {
  try {
    const data = postData.data;

    const response = await axios.post(`${Api}/api/home/getAllUserPlan`, data);
    return response.data.result;
  } catch (e) {
    return e;
  }
};

export const saveSettlementAnswersResponse = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiH}api/eligibility/saveEligibilityQuestionResponse`,
      data
    );
    return response.data.result;
  } catch (e) {
    return e;
  }
};

export const updateBusinessCompanySave = async (postData) => {
  try {
    // console.log
    const data = {
      companyProfileId: postData.companyProfileId,
      companyName: postData.cCompanyName,
      streeAddress: postData.cStreeAddress,
      city: postData.cCity,
      stateId: postData.cState,
      zipCode: postData.cZipCode,
      businessTypeId: 1,
      industryTypeId: postData.cIndustryTypeId,
      separateTaxId: postData.cSeparateTaxId,
      taxId: postData.cTaxId,
      webSite: postData.cWebSite,
      acceptCC: postData.cAcceptCC,
      startingYear: postData.cStartingYear,
      bankruptcyStatus: postData.cBankruptcyStatus,
      dissolvedStatus: postData.cDissolvedStatus,
      contactName: postData.cContactName,
      contactEmail: postData.cContactEmail,
      contactNumber: postData.cContactNumber.replace(/\s/g, ''),
      ein: postData.cEin,
      entityName: postData.cEntityName,
      otherIndustryType: postData.cOtherIndustryType,
    };
    const response = await axios.post(
      `${Api}api/business/saveChildCompanyProfile`,
      data
    );
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const getUpdateAffiliateUserData = async (postData) => {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;
  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();
  const params = {
    UserPoolId: userPoolId,
    Username: postData.cognitoId,
    UserAttributes: [
      {
        Name: 'phone_number',
        Value: postData.cCountryCode + postData.phoneNumber.replace(/\s/g, ''),
      },
      {
        Name: 'custom:first_name',
        Value: postData.firstName.toString(),
      },
      {
        Name: 'custom:last_name',
        Value: postData.lastName.toString(),
      },
      {
        Name: 'email',
        Value: postData.email.toLowerCase(),
      },
    ],
  };

  cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err) => {
    if (err) {
      return err;
    }
    return true;
  });
  params.UserAttributes = [
    {
      Name: 'email_verified',
      Value: 'true',
    },
  ];
  cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err) => {
    if (err) {
      // empty
    }
  });
  try {
    const data = {
      firstName: postData.firstName,
      lastName: postData.lastName,
      phoneNumber: postData.phoneNumber.toString().replace(/\s/g, ''),
      affiliateType: postData.affiliateType,
      email: postData.email.toLowerCase(),
      cognitoId: postData.cognitoId,
      city: postData.cityId,
      stateId: postData.stateId,
      countryId: postData.countryId,
      userId: postData.userId,
      countryCode: postData.cCountryCode,
      companyName: postData.companyName,
      companyPostion: postData.companyPostion,
      zipCode: postData.zipCode,
      streetAddressOne: postData.streetAddressOne,
      streetAddressTwo: postData.streetAddressTwo,
      parentPartnerId: postData.parentPartnerId
    };
    const response = await axios.post(
      `${Api}api/affiliate/updateAffiliateUser`,
      data
    );

    localStorage.setItem('firstName', postData.firstName);
    localStorage.setItem('lastname', postData.lastName);

    const data1 = {
      response: response.data.status,
      status: true,
    };
    return data1;
  } catch (e) {
    return { code: 400 };
  }
};
export const updateBusinessCompanyDataSave = async (postData) => {
  try {
    const data = {
      childCompanyProfileId: postData.childCompanyProfileId,
      companyProfileId: postData.companyProfileId,
      companyName: postData.cCompanyName,
      streeAddress: postData.cStreeAddress,
      city: postData.cCity,
      stateId: postData.cState,
      zipCode: postData.cZipCode,
      businessTypeId: 1,
      industryTypeId: postData.cIndustryTypeId,
      separateTaxId: postData.cSeparateTaxId,
      taxId: postData.cTaxId,
      webSite: postData.cWebSite,
      acceptCC: postData.cAcceptCC,
      startingYear: postData.cStartingYear,
      bankruptcyStatus: postData.cBankruptcyStatus,
      dissolvedStatus: postData.cDissolvedStatus,
      contactName: postData.cContactName,
      contactEmail: postData.cContactEmail,
      contactNumber: postData.cContactNumber.replace(/\s/g, ''),
      ein: postData.cEin,
      entityName: postData.cEntityName,
      otherIndustryType: postData.cOtherIndustryType,
    };

    const response = await axios.post(
      `${Api}api/business/updateChildCompanyProfile`,
      data
    );
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const deleteCompanyChildRecordSave = async (postData) => {
  try {
    const data = { childCompanyProfileId: postData.id };
    const response = await axios.post(
      `${Api}api/business/deleteChildCompanyProfile`,
      data
    );

    // const response1 = await axios.post(`${Api}api/business/getAllChildCompanyProfile`,info );

    // let data1={response:response.data.status,
    //             response1:response1.data.result.records,
    //    status:true,
    // };
    return response.data.code;
  } catch (e) {
    return { code: 400 };
  }
};

export const changeForgetPassword = async (fData) => {
  try {
    const email = fData.data.email.toLowerCase();

    const response = await Auth.forgotPassword(email.toLowerCase());
    return { code: 200, response };
  } catch (error) {
    return { code: 400, error };
  }
};

export const resetPassword = async (fData) => {
  try {
    const email = fData.data.email.toLowerCase();
    const response = Auth.forgotPasswordSubmit(
      email.toLowerCase(),
      fData.data.code,
      fData.data.password
    );

    // const data = await response.json();
    return { code: 200, response };
  } catch (error) {
    return { code: 400, error };
  }
};

export const getAllPlans = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(`${Api}api/home/getAllUserPlan`, data);
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const ConfirmCodeApi = async (info) => {
  try {
    const data = info.data;

    // let postdata = {email: data.email , code: data.code};
    const response = await Auth.confirmSignUp(
      data.email.toLowerCase(),
      data.code
    );
    // const data = await response.json();
    // console.log(response);
    return { code: 200, status: response };
  } catch (e) {
    return { code: 400 };
  }
};

export const getForBusinessAndIndustry = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(`${Api}api/home/getLookTypeValues`, data);

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const SettlemetEnrichmentQuestionApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiG}api/enrichment/getAllEnrichmentQuestionWithoutAnswer`,
      data
    );
    // old used  api/enrichment/getAllEnrichmentQuestion
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllSettlementApi = async (info) => {
  const config = {
    headers: {
      userId: localStorage.getItem('userId'),
    },
  };
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getAllSettlement`,
      data,
      config
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// getPromotedSettlementByUserIdData
export const getPromotedSettlementByUserIdData = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getPromotedSettlementByUserId`,
      data
    );
    // old used  api/enrichment/getAllEnrichmentQuestion
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAllNotificationsApi = async (data) => {
  const userId = localStorage.getItem('userId');
  // data.userId = userId;
  const config = {
    headers: {
      userId,
    },
  };
  try {
    const response = await axios.post(
      `${Api}api/user/getNotificationLogForUser`,
      data,
      config
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const deleteNotificationApi = async (data) => {
  const userId = localStorage.getItem('userId');
  const config = {
    headers: {
      userId,
    },
  };
  try {
    const response = await axios.post(
      `${Api}api/user/deleteNotification`,
      data,
      config
    );
    if (response.status === 401) {
      return { status: 400 };
    }
    return response.data;
  } catch (e) {
    return { status: 400 };
  }
};

export const markNotificationApi = async data => {
  const userId = localStorage.getItem("userId");
  const config = {
    headers: {
      userId
    }
  };
  try {
    const response = await axios.post(
      `${Api}api/user/markNotificationReadForUser`,
      data,
      config
    );
    if (response.status === 401) {
      return { status: 400 };
    }
    return response.data;
  } catch (e) {
    return { status: 400 };
  }
};

export const getAllFilteredSettlementApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getFilteredSettlementWithStatus`,
      data
    );
    if (response.data.status === 'NOT_FOUND') {
      return ['NOT_FOUND'];
    }
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    if (response.code === 401) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAllFilteredDSettlementApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getDashboardSettlements`,
      data
    );
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getSettlementListByAffiliateTypeData = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getSettlementListByAffiliateType`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }
    if (response.data.code === 200) {
      return response.data;
    }
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getEnrollForPartnerUserApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getFilteredEnrollSettlementForPartner`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 200) {
    //   return response.data;
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};
export const getSettlementListForGroupApi = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getSettlementListForGroup`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 200) {
    //   return response.data;
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllReferredUserByAffiliateIdData = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAllReferredUserByAffiliateId`,
      data
    );

    // if (response.code === 401) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllGroupsByParentAffiliateUserData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAllGroupsByParentAffiliateUser`,
      data
    );

    // if (response.code === 401) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllPartnersByGroupData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAllPartnersByGroup`,
      data
    );

    // if (response.code === 401) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllHierarchyChildAffiliateUsersByParentAffiliateUserData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAllHierarchyChildAffiliateUsersByParentAffiliateUser`,
      data
    );

    // if (response.code === 401) {
    //   return { code: 400 };
    // }
    // if (response.data.code === 404) {
    //   return { code: 400 };
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};


export const getEnrolledListByAffiliateIdData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getEnrolledListBySearchAndFilter`,
      data
    );
    // console.log("niraj",response.data.result)
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }
    // if (response.data.code === 200) {
    //   // console.log("sadasdsad")
    //   return data;
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getEnrolledListBySearchAndFilterForGroupData = async info => {
  console.log("dataapi",info)
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getEnrolledListBySearchAndFilterForGroup`,
      data
    );
    // console.log("niraj",response.data.result)
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }
    // if (response.data.code === 200) {
    //   // console.log("sadasdsad")
    //   return data;
    // }
    // if (response.data.result === undefined) {
    //   // console.log("sadasdsad")
    //   return [];
    // }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllEnrolledSettlementApi = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getFilteredEnrollSettlement`,
      data
    );
    // console.log(response)
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: response.data.collectMessage };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAllCategoryAPI = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getAllCategory`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result.records;
  } catch (e) {
    return [];
  }
};

export const getEnrollSettlementForUserApi = async (info) => {
  /**
     *
     {

       "settlementStatusType" : "In Progress",

       "userId":"11"

     }
     */
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getEnrollSettlementForUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAttentionSettlementForUserApi = async (info) => {
  /**
     *
     {

       "settlementStatusType" : "Need Attention",

       "userId":"11"

     }
     */
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getEnrollSettlementForUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getCompleteSettlementForUserApi = async (info) => {
  /**
     *
     {

       "settlementStatusType" : "Need Attention",

       "userId":"11"

     }
     */
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getEnrollSettlementForUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const moveToNextQuestionListApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiH}api/eligibility/getFirstEligibilityQuestion`,
      data
    );
    if (response.data.result === undefined) {
      return [];
    }
    if (response.code === 401) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const saveToNextQuestionListApi = async (postData) => {
  try {
    const data = postData.data;
    const response = await axios.post(
      `${ApiH}api/eligibility/saveEligibilityQuestionResponseWithSkip`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// getAutoPartDefendentPartsByPartIdApi

export const getAutoPartDefendentPartsByPartIdApi = async (postData) => {
  try {
    const response = await axios.post(
      `${ApiH}api/eligibility/getAutoPartDefendentPartsByPartId`,
      postData
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// saveUsersUneligibleSettlementsApi

export const saveUsersUneligibleSettlementsApi = async (postData) => {
  try {
    const response = await axios.post(
      `${ApiH}api/eligibility/saveUsersUneligibleSettlements`,
      postData
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getEligibilityQuestionByIdApi = async (postData) => {
  try {
    const data = postData.data;
    const response = await axios.post(
      `${ApiH}api/eligibility/getEligibilityQuestionById`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAlLFeatureSettlementApi = async (info) => {
  /** const config = {
        headers: {
            'userId': userid
        }
    }* */
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getAlLFeatureSettlement`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const saveEnrichmentQuestionAnswerApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiG}api/enrichment/saveEnrichmentAnswer`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getCognitoIdByEmailOfUser = async (info) => {
  try {
    const data = { email: info.data };
    const response = await axios.post(
      `${Api}api/home/getCognitoIdByEmail`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (!response.data.result) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const ConfirmUserCodeApi = async (info) => {
  try {
    const data = info.data;
    const response = await Auth.confirmSignUp(
      data.email.toLowerCase(),
      data.code
    );
    return { code: 200, status: response };
  } catch (e) {
    return { code: 400 };
  }
};

export const getSettlementById = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getSettlementById`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// save Affiliate sub user
export const saveAffilateSubUserSignUp = async (postData) => {
  try {
    const data = postData;
    const info = {
      username: data.email.toLowerCase(),
      password: data.password,
      attributes: {
        email: data.email.toLowerCase(),
        phone_number: (data.countryCode + data.phone)
          .toString()
          .replace(/\s/g, ''),
        'custom:first_name': data.firstname.toString(),
        'custom:last_name': data.lastname.toString(),
      },
    };
    const response = await Auth.signUp(info);
    /* if(response ===401){
            return {code:400};
        } */
    return response;
  } catch (e) {
    return { code: 400 };
  }
};
export const saveBusinessSubUserSignUp = async (postData) => {
  try {
    const data = postData;
    const info = {
      username: data.email.toLowerCase(),
      password: data.password,
      attributes: {
        email: data.email.toLowerCase(),
        phone_number: (data.countryCode + data.phone).replace(/\s/g, ''),
        'custom:first_name': data.firstname.toString(),
        'custom:last_name': data.lastname.toString(),
        'custom:title': data.title.toString(),
        'custom:workphonenumber': (data.workCountryCode + data.workPhone)
          .toString()
          .replace(/\s/g, ''),
      },
    };
    const response = await Auth.signUp(info);
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const saveAffilateSubUserSignUpServer = async (data, resp) => {
  try {
    const userId = localStorage.getItem('userId');
    const phone = data.phone;
    const countryCode = data.countryCode;
    const info = {
      email: data.email.toLowerCase(),
      firstName: data.firstname.toString(),
      lastName: data.lastname.toString(),
      phoneNumber: phone,
      roleName: 'Affiliate-SubUser',
      userId,
      countryCode,
      cognitoId: resp.userSub,
      password: data.password,
      applicationUrl,
    };
    aws.config.accessKeyId = accessKeyId;
    aws.config.secretAccessKey = secretAccessKey;
    aws.config.region = region;
    const params = {
      UserPoolId: userPoolId,
      Username: data.email.toLowerCase(),
    };
    const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

    await cognitoidentityserviceprovider.adminConfirmSignUp(params, () => {});
    params.UserAttributes = [
      {
        Name: 'email_verified',
        Value: 'true',
      },
    ];
    await updateUser(params);

    // const response1 = axios.post(`${Api}api/affiliate/saveAffiliateSubUser`,info );
    /* axios.post(`${Api}api/affiliate/saveAffiliateSubUser`, info).then((res)=>{
            console.log('response',res);
            return res;
        }) */
    const response = await axios.post(
      `${Api}api/affiliate/saveAffiliateSubUser`,
      info
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};
export const saveBusinessSubUserSignUpServer = async (data, resp) => {
  // console.log("res sadsadsa", resp )

  // console.log("resp", data )
  try {
    const userId = localStorage.getItem('userId');
    const phone = data.phone;
    const workphone = data.workPhone;
    const countryCode = data.countryCode;
    const workcountryCode = data.workCountryCode;
    const info = {
      email: data.email.toLowerCase(),
      firstName: data.firstname.toString(),
      lastName: data.lastname.toString(),
      mobilePhone: phone,
      roleName: 'Business-SubUser',
      businessUserId: userId,
      countryCode,
      cognitoClientId: resp.userSub,
      workPhoneNumber: workphone,
      workCountryCode: workcountryCode,
      companyTitle: data.title.toString(),
      applicationUrl: SecretKeys.REACT_APP_FRONTEND_URL,
      password: data.password,
    };
    aws.config.accessKeyId = accessKeyId;
    aws.config.secretAccessKey = secretAccessKey;
    aws.config.region = region;
    const params = {
      UserPoolId: userPoolId,
      Username: data.email.toLowerCase(),
    };
    const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

    await cognitoidentityserviceprovider.adminConfirmSignUp(params, () => {});
    params.UserAttributes = [
      {
        Name: 'email_verified',
        Value: 'true',
      },
    ];
    await updateUser(params);
    const response = await axios.post(
      `${Api}api/business/saveBusinessSubUser`,
      info
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const updateAffiliateSubUserData = async (postData) => {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;
  const data = postData.data;
  const params = {
    UserPoolId: userPoolId,
    Username: data.cognitoUserId,
    UserAttributes: [
      {
        Name: 'phone_number',
        Value: data.countryCode + data.phone.replace(/\s/g, ''),
      },
      {
        Name: 'custom:first_name',
        Value: data.firstname.toString(),
      },
      {
        Name: 'custom:last_name',
        Value: data.lastname.toString(),
      },
    ],
  };
  const responseData = await updateUser(params);
  if (responseData === '') {
    // console.log("data",responseData)
  } else {
    try {
      const info = {
        firstName: postData.data.firstname.toString(),
        lastName: postData.data.lastname.toString(),
        phoneNumber: postData.data.phone.replace(/\s/g, ''),
        affiliateSubUserId: postData.data.affiliateSubUserId,
        countryCode: postData.data.countryCode,
      };
      const response = await axios.post(
        `${Api}api/affiliate/updtaeAffiliateSubUser`,
        info
      );
      return response.data;
    } catch (e) {
      return e;
    }
  }
  return true;
};

export const updateBusinessSubUserData = async (postData) => {
  aws.config.accessKeyId = accessKeyId;
  aws.config.secretAccessKey = secretAccessKey;
  aws.config.region = region;
  const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();
  const data = postData.data;
  const params = {
    UserPoolId: userPoolId,
    Username: data.cognitoClientId,
    UserAttributes: [
      {
        Name: 'phone_number',
        Value: data.countryCode + data.phone.replace(/\s/g, ''),
      },
      {
        Name: 'custom:first_name',
        Value: data.firstname.toString(),
      },
      {
        Name: 'custom:last_name',
        Value: data.lastname.toString(),
      },
      {
        Name: 'custom:title',
        Value: data.title.toString(),
      },
      {
        Name: 'custom:workphonenumber',
        Value: data.workCountryCode + data.workPhone.replace(/\s/g, ''),
      },
    ],
  };

  cognitoidentityserviceprovider.adminUpdateUserAttributes(params, (err) => {
    if (err) {
      return err;
    }
    return true;
  });
  try {
    const phone = postData.data.phone;
    const countryCode = postData.data.countryCode;
    const dataPhone = {
      businessSubUserId: postData.data.businessSubUserId,
      firstName: postData.data.firstname.toString(),
      lastName: postData.data.lastname.toString(),
      mobilePhone: phone,
      countryCode,
      workPhoneNumber: postData.data.workPhone,
      workCountryCode: postData.data.workCountryCode,
      companyTitle: postData.data.title,
    };

    const response = await axios.post(
      `${Api}api/business/updateBusinessSubUser`,
      dataPhone
    );
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAffliliateUsers = async () => {
  try {
    const data = { userId: localStorage.getItem('userId') };
    const response = await axios.post(
      `${Api}api/affiliate/getAllAffiliateSubUser`,
      data
    );
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAffiliateDetailByAffiliateKeyData = async (postData) => {
  // console.log("postData",postData)
  try {
    const data = { affiliateKey: postData };
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateDetailByAffiliateKeyNew`,
      data
    );
    return response.data;
  } catch (e) {
    return [];
  }
};

export const getBusinesssSubUsers = async () => {
  try {
    const data = {
      userId: localStorage.getItem('userId'),
      pageNumber: 0,
      pageSize: 100,
      searchKeyword: '',
    };
    const response = await axios.post(
      `${Api}api/business/getAllBusinessSubUserByBusinessUserId`,
      data
    );

    if (response.data.result === undefined) {
      return [];
    }
    return response.data.result.records;

    // return response.data.result.records;
  } catch (e) {
    return [];
  }
};
export const deteteAffliliateUsers = async (postData) => {
  // console.log('ssssssssssss',postData)
  try {
    aws.config.accessKeyId = accessKeyId;
    aws.config.secretAccessKey = secretAccessKey;
    aws.config.region = region;

    let params = {
      UserPoolId: SecretKeys.awsUserpool.userPoolId,
      Username: postData.cognitoClientId,
    };

    const cognitoidentityserviceprovider = new aws.CognitoIdentityServiceProvider();

    // cognitoidentityserviceprovider.adminDeleteUser(params, function(err, data) {
    await cognitoidentityserviceprovider.adminDeleteUser(params, (err1) => {
      if (err1) {
        // empty
      }
    });

    const data = { affiliateSubUserId: postData.id };
    const response = await axios.post(
      `${Api}api/affiliate/deleteAffiliateSubUserId`,
      data
    );
    return response.data.code;
  } catch (e) {
    return { code: 400 };
  }
};
export const deteteBusinessUsers = async (postData) => {
  try {
    const data1 = {
      userId: localStorage.getItem('userId'),
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: '',
    };
    const data = { businessSubUserId: postData.id };
    const response = await axios.post(
      `${Api}api/business/deleteBusinessSubUser`,
      data
    );
    const response1 = await axios.post(
      `${Api}api/business/getAllBusinessSubUserByBusinessUserId`,
      data1
    );
    const v = {
      res: response.data,
      res2: response1.data,
    };
    return v;
  } catch (e) {
    return { code: 400 };
  }
};

export const uploadEnrolmentDoc = async (info) => {
  try {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/uploadMultipleEnrollmentDoc`,
      data,
      config
    );
    // const response = await axios.post(`${ApiF}api/settlement/uploadEnrollmenttDoc`, data, config);

    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const updateUploadEnrolmentDoc = async (info) => {
  try {
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/updateUploadEnrollDoc`,
      data,
      config
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const emailVeriy = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(`${Api}api/home/emailVerify`, data);
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const enrollmentAuthorizationApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/enrollmentAuthorization`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAffiliateType = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getAffiliateSubUserDataById = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateSubUserById`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};
export const getBusinessSubUserDataById = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/business/getBusinessSubUserById`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllUserResidenceByUserId = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/user/getAllUserResidenceByUserId`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.result) {
      return response.data.result;
    }
    return [];
  } catch (e) {
    return { code: 400 };
  }
};

export const getPendingRequiredDocApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getPendingRequiredDoc`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getPendingRequiredDocUserApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getAllRequiredDocByUserIdAndSettlementId`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getPendingRequiredDocUserDeleteApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/deleteUploadEnrollDoc`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.result === undefined) {
      // console.log("sadasdsad")
      return [];
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllVehicleDataByUserIdAPI = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/user/getAllFilteredVehicleDataByUserId`,
      data
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getAllVehicleDataSettlementByUserIdAPI = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getVehicleDetailForSettlement`,
      data
    );
    // console.log('response', response.data.code);
    if (response.data.code === 404) {
      return [];
    }
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const saveMultipleVehicleDataByUserIdAPIList = async (info) => {
  try {
    const data = info;
    const response = await axios.post(
      `${Api}api/user/updateMultipleVehicleData`,
      data
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getAllSettlementListOfUserByIdData = async (info) => {
  try {
    // console.log(info.userId)
    const data = {
      userId: info.userId,
      id: info.id,
    };
    const response = await axios.post(
      `${ApiF}api/settlement/getAllSettlementListOfUserById`,
      data
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getAllSettlementListOfUserByIdForGroupData = async info => {
  try {
    console.log("patcher",info)
    const data = {
      userId: info.userId,
      id: info.id,
      groupId: info.groupId
    };
    const response = await axios.post(
      `${ApiF}api/settlement/getAllSettlementListOfUserByIdForGroup`,
      data
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getSettlementDetailForGroupData = async info => {
  try {
    const data = {
      userId: info.userId,
      id: info.id,
      partnerId: info.partnerId
    };
    const response = await axios.post(
      `${ApiF}api/settlement/getSettlementDetailForGroup`,
      data
    );
    return response.data.result;
  } catch (e) {
    return [];
  }
};

export const getPendingEligibilityQuestionApi = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiH}api/eligibility/getAllPendingEligiblityQuestionBySettlementId`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const requestDismissSettlementApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/dismissUnDismissSettlement`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getFaqCategories = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(`${ApiE}api/faq/getFaqCategory`, data);
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result.records;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllFaqQuestion = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiE}api/faq/getAllFaqQuestionBYCategoryId`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result.records;
  } catch (e) {
    return { code: 400 };
  }
};

export const getPageDetails = async (info) => {
  try {
    const data = { sitePageId: info.data };
    const response = await axios.post(
      `${ApiE}api/content/getSitePageById`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getUserByIdentityKeyApi = async (info) => {
  try {
    const data = {
      userId: info.data.userId,
      identityKey: info.data.siteKey,
      agreementId: info.data.agreementId,
    };
    const response = await axios.post(
      `${ApiE}api/content/getUserByIdentityKey`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 410) {
      return response.data.status;
    }
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const acceptDocumentUpdateByAdmin = async (info) => {
  try {
    const data = {
      userId: info.data.userId,
      acceptAgreement: 1,
      agreementId: info.data.agreementId,
    };
    const response = await axios.post(
      `${ApiE}api/content/acceptDocumentUpdateByAdmin`,
      data
    );
    // console.log('response', response)
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.status;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAffiliateDashboardUserAPI = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateDashboardUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAffiliateDashboardUserForParentAPI = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateDashboardUserForParent`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

// getBarGraphDataForDashboardData
export const getBarGraphDataForDashboardData = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getBarGraphDataForDashboard`,
      data
    );
    return response.data.result ? response.data.result : [];
  } catch (e) {
    return { code: 400 };
  }
};
export const getPieChartDataForDashboardData = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getPieChartDataForDashboard`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getBarGraphDataForDashboardWithSettlementIdForParentUserData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getBarGraphDataForDashboardWithSettlementIdForParentUser`,
      data
    );
    return response.data.result ? response.data.result : [];
  } catch (e) {
    return { code: 400 };
  }
};

export const getMonthlyEnrollmentsByAffiliateGroupData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getMonthlyEnrollmentsByAffiliateGroup`,
      data
    );
    return response.data.result ? response.data.result : [];
  } catch (e) {
    return { code: 400 };
  }
};

export const getBarGraphDataForDashboardWithSettlementIdForParentUserForGroupData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup`,
      data
    );
    return response.data.result ? response.data.result : [];
  } catch (e) {
    return { code: 400 };
  }
};

export const getPieChartDataForStateDashboardData = async info => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getPieChartStateDataForDashboard`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const planPriceUpdate = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(`${Api}api/home/planPriceChange`, data);
    if (info.data.paymentStatus) {
      const data2 = {
        userId: info.data.userId,
        paymentStatus: info.data.paymentStatus,
      };
      await axios.post(`${Api}api/user/updateUserPaymentStatus`, data2);
    }

    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.result.selectedPlanName) {
      await localStorage.setItem('planName', response.data.result.selectedPlanName);
      await localStorage.setItem('paymentStatus', info.data.paymentStatus);
    }
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getDismissSettlementForUserApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/getDismissSettlementForUser`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllAffiliateLinkForUserApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${Api}api/affiliate/getAllEnabledAffiliateLink`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const saveSettlementWithoutDataApi = async (info) => {
  try {
    const data = info.data;
    const response = await axios.post(
      `${ApiF}api/settlement/saveDirectEnrollWithUserAndSettlement`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }

    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const uploadChildCompany = async (formData) => {
  try {
    const data = formData;
    const response = await axios.post(
      `${Api}api/business/uploadChildCompany`,
      data
    );
    if (response.code === 401) {
      return { code: 400 };
    }
    if (response.data.code === 404) {
      return { code: 400 };
    }

    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllDashboardApi = async (formData) => {
  try {
    const response = await axios.post(
      `${ApiF}api/settlement/getUserDashboardSettlements`,
      formData
    );
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const getAllDashboardCountApi = async (formData) => {
  try {
    const response = await axios.post(
      `${ApiF}api/settlement/getUserDashboardSettlementsCounts`,
      formData
    );
    return response.data;
  } catch (e) {
    return { code: 400 };
  }
};

export const GetAllAffiliateUsersByAffiliateTypeApi = async (formData) => {
  try {
    const response = await axios.post(
      `${Api}/api/affiliate/getAllAffliateUsersByAffiliateType`,
      { roleName: formData }
    );
    return response.data.result;
  } catch (e) {
    return { code: 400 };
  }
};

export const fusebillCreateCustomer = async (uData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };

    // Create Customer
    const response = await axios.post(
      `${fusebillApiUrl}customers`,
      uData.customerInfo,
      config
    );

    // Activate Customer
    const dataCustomer = {
      customerId: response.data.id,
      activateAllSubscriptions: true,
      activateAllDraftPurchases: true,
      temporarilyDisableAutoPost: false,
    };

    await axios.post(
      `${fusebillApiUrl}customerActivation`,
      dataCustomer,
      config
    );

    const billingAddress = {
      customerAddressPreferenceId: response.data.id,
      companyName: uData.billing.companyName,
      line1: uData.billing.line1,
      line2: uData.billing.line2,
      city: uData.billing.city,
      postalZip: uData.billing.postalZip,
      country: uData.billing.country,
      state: uData.billing.state,
      addressType: 'Billing',
    };

    const response2 = await axios.post(
      `${fusebillApiUrl}Addresses`,
      billingAddress,
      config
    );

    // Add fusebill customer ID to DB.
    const data2 = {
      userId: uData.customerInfo.userId,
      fusebillCustomerId: response.data.id,
      fusebillAddressId: response2.data.id,
    };
    await axios.post(
      `${Api}api/business/updateFusebillCustomerIdByUserId`,
      data2
    );
    await localStorage.setItem('paymentStatus', 'pending');
    localStorage.setItem('fusebillBillingAddressId', response2.data.id);

    // test

    // const user = { userId: uData.customerInfo.userId };
    const selectedPlanName = uData.postData.postData.selectedPlanName;
    const fusebillCustomerId = response.data.id;

    const dataString = `CustomerId=${fusebillCustomerId}&PublicApiKey=${
      SecretKeys.FUSEBILL.PUBLIC_API_KEY
    }&SuccessUri=${''}&FailUri=${''}&CardNumber=${uData.postData.postData.cardNumber
      .replace(/_/g, '')
      .replace(/ /g, '')}&FirstName=${
      uData.postData.postData.cardFirstName
        ? uData.postData.postData.cardFirstName
        : uData.postData.postData.firstName
    }&LastName=${
      uData.postData.postData.cardLastName
        ? uData.postData.postData.cardLastName
        : uData.postData.postData.lastName
    }&ExpirationMonth=${uData.postData.postData.cardMonth.replace(
      /_/g,
      ''
    )}&ExpirationYear=${uData.postData.postData.cardYear.replace(
      /_/g,
      ''
    )}&makeDefault=${true}&Cvv=${uData.postData.postData.cardCvv.replace(
      /_/g,
      ''
    )}&email=${uData.postData.postData.email}&address1=${
      uData.postData.postData.cardAddress
    }&address2=${uData.postData.postData.cardAddress2}&city=${
      uData.postData.postData.cardCity
    }&state=${uData.postData.postData.state}&country=${
      uData.postData.postData.countryCode
    }&postalZip=${uData.postData.postData.cardZipCode}&recaptcha=${
      uData.postData.postData.recaptchaToken
    }`;

    if (
      selectedPlanName !== 'Basic' &&
      selectedPlanName !== 'Basic Outsourced' &&
      fusebillCustomerId
    ) {
      // if (localStorage.getItem('fusebillBillingAddressId')) {
      //   const billingAddress = {
      //     customerAddressPreferenceId: localStorage.getItem('fusebillCustomerId'),
      //     id: localStorage.getItem('fusebillBillingAddressId'),
      //     // companyName: postData.data.companyName,
      //     line1: uData.postData.cardAddress,
      //     country: 'United States',
      //     state: uData.postData.state,
      //     city: uData.postData.cardCity,
      //     postalZip: uData.postData.cardZipCode,
      //     addressType: 'Billing',
      //   };
      //   // await axios.put(`${fusebillApiUrl}Addresses`, billingAddress, config);
      // }
    }

    // console.log('ssssssssssssssdataChangePlain', dataString)

    // await axios.post(`${Api}api/home/planPriceChange`, dataChangePlain);

if(uData.postData.postData.connectFusebill !=0){
  await axios.post(
    "https://payments.subscriptionplatform.com/api/paymentsv2/",
    dataString
  );
}


    // console.log('ssssssssssssssdataChangePlain', responsepayment, fusebillCustomerId, response.data.id, uData.postData.postData)

    const data1 = {
      customerID: fusebillCustomerId,
      planFrequencyID: uData.postData.postData.fusebillPlanFrequencyId,
    };

    // console.log('ssssssssssssssdataChangePlain', data1, uData)

    let planProductWithFlexCompanyCount;

    let EIN = 0;
    // Capping EIN count to 250.
    console.log(
      'uData.postData.postData.enterpriseType',
      uData.postData.postData.enterpriseType
    );
    if (uData.postData.postData.enterpriseType === 'S') {
      if (parseInt(uData.postData.postData.totalTaxId, 10) <= 250) {
        EIN = parseInt(uData.postData.postData.totalTaxId, 10);
      } else {
        EIN = 250;
      }
    }
    // console.log(
    //   "uData.postData.postData.enterpriseType",
    //   uData
    // );
if(uData.postData.postData.connectFusebill != 0) {
    const responsesubscriptions = await axios.post(
      `${fusebillApiUrl}subscriptions`,
      data1,
      config
    );

    responsesubscriptions.data.subscriptionProducts.forEach((planProduct) => {
      if (
        planProduct.planProduct.productCode === 'flexcompanycount' ||
        planProduct.planProduct.productCode === 'premiumcompanycount'
      ) {
        planProductWithFlexCompanyCount = planProduct;
        planProductWithFlexCompanyCount.planProduct.quantity = EIN;
        planProductWithFlexCompanyCount.quantity = EIN;
      }
    });

    // console.log('ssssssssssssssdataChangePlain', data1, planProductWithFlexCompanyCount, uData, responsesubscriptions, responsesubscriptions.data.id)

    await axios.put(
      `${fusebillApiUrl}SubscriptionProducts/${responsesubscriptions.data.id}`,
      planProductWithFlexCompanyCount,
      config
    );

    let subscriptionProductId;
    responsesubscriptions.data.subscriptionProducts.forEach((planProduct) => {
      if (
        planProduct.planProduct.productCode === 'flexsubscription' ||
        planProduct.planProduct.productCode === 'premiumsubscription'
      ) {
        subscriptionProductId = planProduct.id;
      }
    });

    const priceOverride = {
      id: subscriptionProductId,
      chargeAmount: parseFloat(
        uData.postData.postData.selectedPlanAmount
      ).toFixed(2),
      priceRanges: [
        {
          min: 0,
          max: null,
          price: parseFloat(uData.postData.postData.selectedPlanAmount).toFixed(
            2
          ),
        },
      ],
      pricingModelType: 'Standard',
    };

    await axios.put(
      `${fusebillApiUrl}SubscriptionProductPriceOverrides`,
      priceOverride,
      config
    );

    await axios.post(
      `${fusebillApiUrl}subscriptionActivation/${responsesubscriptions.data.id}`,
      {},
      config
    );
    }
    // console.log('ssssssssssssssdataChangePlain', responsesubscriptionActivation)

    // // If subscription has been successfully activated.
    // if (responsesubscriptionActivation.data.id !== undefined) {
    //   // Add subscription ID to DB.
    //   const data3 = {
    //     userId: uData.customerInfo.userId,
    //     fusebillSubscriptionId: responsesubscriptionActivation.data.id,
    //   };
    //   await axios.post(`${Api}api/business/updateFusebillCustomerIdByUserId`, data3);
    //   // Set payment status paid.
    const dataPaid = {
      userId: uData.customerInfo.userId,
      paymentStatus: 'paid',
    };
    await axios.post(`${Api}api/user/updateUserPaymentStatus`, dataPaid);
    // }
    // await localStorage.setItem('fusebillCustomerId', response.data.result.fusebillCustomerId);
    // await localStorage.setItem('fusebillCardId', response.data.result.fusebillCardId);
    // await localStorage.setItem('fusebillSubscriptionId', responsesubscriptions.data.id);

    // console.log('responsepayment', responsepayment, responsesubscriptions)

    return {
      fusebillCustomerId: response.data.id,
      fusebillBillingAddressId: response2.data.id,
    };
  } catch (e) {
    return { code: 400 };
  }
};

export const fusebillAddPaymentMethod = async (postData) => {
  try {
    // const user = { userId: postData.postdata.userIdState };
    // const userResponse = await axios.post(`${Api}api/business/getBusinessUser`, user);
    // console.log('userResponse', userResponse)
    const selectedPlanName = postData.postdata.selectedPlanName;
    const planPriceId = postData.postdata.planPriceId;
    // const fusebillCustomerId = userResponse.data.result.fusebillCustomerId;

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };

    // if (selectedPlanName !== 'Basic'
    //   && selectedPlanName !== 'Basic Outsourced'
    //   && fusebillCustomerId) {
    // Fusebill customer update----------
    // if (localStorage.getItem('fusebillCustomerId')) {
    //   const customerInfo = {
    //     id: localStorage.getItem('fusebillCustomerId'),
    //     firstName: postData.data.firstName,
    //     lastName: postData.data.lastName,
    //     companyName: postData.data.companyName,
    //     Status: 'Active',
    //   };
    //   await axios.put(`${fusebillApiUrl}customers`, customerInfo, config);
    // }
    // Fusebill Billing address update-----
    // if (localStorage.getItem('fusebillBillingAddressId')) {
    //   const billingAddress = {
    //     customerAddressPreferenceId: localStorage.getItem('fusebillCustomerId'),
    //     id: localStorage.getItem('fusebillBillingAddressId'),
    //     // companyName: postData.data.companyName,
    //     line1: postData.data.address1,
    //     country: 'United States',
    //     state: postData.data.stateId,
    //     city: postData.data.city,
    //     postalZip: postData.data.postalZip,
    //     addressType: 'Billing',
    //   };
    //   await axios.put(`${fusebillApiUrl}Addresses`, billingAddress, config);
    // }
    // }
    const data = postData;
    let totalAmount;

    if (data.postdata.durationData === "1 Month") {
      totalAmount = parseFloat(
        data.postdata.selectedPlanAmount !== ''
          ? data.postdata.selectedPlanAmount.toFixed(
            2,
          )
          : 0.0,
      ) + parseFloat(data.postdata.enterpriseType === "S" ? data.postdata.totalTaxId < 250 ? data.postdata.totalTaxId : 250 : 0)
    } else {

      totalAmount = (
        parseFloat(
          data.postdata.selectedPlanAmount !== ''
            ? data.postdata.selectedPlanAmount.toFixed(
              2,
            )
            : 0.0,
        ) + parseFloat(data.postdata.enterpriseType === "S" ? data.postdata.totalTaxId < 250 ? data.postdata.totalTaxId * data.postdata.durationCheckout * data.postdata.discountCheckout : 250 * data.postdata.durationCheckout * data.postdata.discountCheckout : 0.00)
      ).toFixed(2);
    }
    // console.log('data============', totalAmount)
    // debugger
    const dataChangePlain = {
      paymentStatus:
        postData.postdata.selectedPlanName !== 'Basic' ? 'pending' : 'paid',
      planPriceId,
      selectedPlanAmount: totalAmount,
      selectedPlanName,
      userId: postData.postdata.userIdState,
    };
    await axios.post(`${Api}api/home/planPriceChange`, dataChangePlain);

    await localStorage.setItem('planName', postData.postdata.selectedPlanName);
    await localStorage.setItem(
      'plainNameDto',
      postData.postdata.selectedPlanName
    );

    await localStorage.setItem('paymentStatus', 'paid');

    const response = await axios.post(
      'https://payments.subscriptionplatform.com/api/paymentsv2/',
      postData.dataString
    );

    if (postData.postdata.planName !== 'Basic') {
      //fusebillPlanFrequencyId
      const data1 = {
        customerID: postData.postdata.customerId,
        planFrequencyID: postData.postdata.fusebillPlanFrequencyId,
      };

      // add
      let planProductWithFlexCompanyCount;

      let EIN = 0;
      // Capping EIN count to 250.
      if (postData.postdata.enterpriseType === 'S') {
        if (parseInt(postData.postdata.totalTaxId, 10) <= 250) {
          EIN = parseInt(postData.postdata.totalTaxId, 10);
        } else {
          EIN = 250;
        }
      }

      const responsesubscriptions = await axios.post(
        `${fusebillApiUrl}subscriptions`,
        data1,
        config
      );

      responsesubscriptions.data.subscriptionProducts.forEach((planProduct) => {
        if (
          planProduct.planProduct.productCode === 'flexcompanycount' ||
          planProduct.planProduct.productCode === 'premiumcompanycount'
        ) {
          planProductWithFlexCompanyCount = planProduct;
          planProductWithFlexCompanyCount.planProduct.quantity = EIN;
          planProductWithFlexCompanyCount.quantity = EIN;
        }
      });

      await axios.put(
        `${fusebillApiUrl}SubscriptionProducts/${responsesubscriptions.data.id}`,
        planProductWithFlexCompanyCount,
        config
      );

      let subscriptionProductId;
      responsesubscriptions.data.subscriptionProducts.forEach((planProduct) => {
        if (
          planProduct.planProduct.productCode === 'flexsubscription' ||
          planProduct.planProduct.productCode === 'premiumsubscription'
        ) {
          subscriptionProductId = planProduct.id;
        }
      });

      const priceOverride = {
        id: subscriptionProductId,
        chargeAmount: parseFloat(postData.postdata.selectedPlanAmount).toFixed(
          2
        ),
        priceRanges: [
          {
            min: 0,
            max: null,
            price: parseFloat(postData.postdata.selectedPlanAmount).toFixed(2),
          },
        ],
        pricingModelType: 'Standard',
      };

      await axios.put(
        `${fusebillApiUrl}SubscriptionProductPriceOverrides`,
        priceOverride,
        config
      );

      await axios.post(
        `${fusebillApiUrl}subscriptionActivation/${responsesubscriptions.data.id}`,
        {},
        config
      );

      // // If subscription has been successfully activated.
      // if (responsesubscriptionActivation.data.id !== undefined) {
      //   // Add subscription ID to DB.
      //   const data3 = {
      //     userId: uData.customerInfo.userId,
      //     fusebillSubscriptionId: responsesubscriptionActivation.data.id,
      //   };
      //   await axios.post(`${Api}api/business/updateFusebillCustomerIdByUserId`, data3);
      //   // Set payment status paid.
      const dataPaid = {
        userId: postData.postdata.userId,
        paymentStatus: 'paid',
      };
      await axios.post(`${Api}api/user/updateUserPaymentStatus`, dataPaid);
      // }
      // await localStorage.setItem('fusebillCustomerId', response.data.result.fusebillCustomerId);
      // await localStorage.setItem('fusebillCardId', response.data.result.fusebillCardId);
      // await localStorage.setItem('fusebillSubscriptionId', responsesubscriptions.data.id);

      // console.log('responsepayment', responsepayment, responsesubscriptions)
    }
    await localStorage.setItem('paymentStatus', 'paid');

    return {
      fusebillCardId: response.data.id,
      addPaymentMthdResponse: response,
    };
  } catch (e) {
    return {
      addPaymentMthdError: e,
      code: 400,
    };
  }
};

export const fusebillSaveCardIdToDB = async (cData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };
    const data = {
      fusebillCardId: cData.cardId,
      userId: cData.userId,
    };

    // Save card ID to DB.
    const response = await axios.post(
      `${Api}api/business/updateFusebillCustomerIdByUserId`,
      data
    );

    const data1 = {
      customerID: response.data.result.fusebillCustomerId,
      planFrequencyID: cData.planFrequencyId,
    };

    // Get the Details of the user.
    const user = { userId: cData.userId };
    const userResponse = await axios.post(
      `${Api}api/business/getBusinessUser`,
      user
    );
    // const totalTaxId = userResponse.data.result.totalTaxId;
    // const selectedPlanName = userResponse.data.result.selectedPlanName;
    // const enterpriseType = userResponse.data.result.enterpriseType;
    /*
    ===================================================================
    const selectedPlanAmount = userResponse.data.result.selectedPlanAmount;

    // Create the subscription for the customer.
    const response1 = await axios.post(
      `${fusebillApiUrl}subscriptions`,
      data1,
      config
    );

    let subscriptionProductId;
    response1.data.subscriptionProducts.forEach((planProduct) => {
      if (
        planProduct.planProduct.productCode === 'flexsubscription' ||
        planProduct.planProduct.productCode === 'premiumsubscription'
      ) {
        subscriptionProductId = planProduct.id;
      }
    });

    const priceOverride = {
      id: subscriptionProductId,
      chargeAmount: selectedPlanAmount,
      priceRanges: [
        {
          min: 0,
          max: null,
          price: selectedPlanAmount,
        },
      ],
      pricingModelType: 'Standard',
    };
    await axios.put(
      `${fusebillApiUrl}SubscriptionProductPriceOverrides`,
      priceOverride,
      config
    );
    // }
    // Activate the subscription of the customer.
    const response2 = await axios.post(
      `${fusebillApiUrl}subscriptionActivation/${response1.data.id}`,
      {},
      config
    );

    // If subscription has been successfully activated.
    if (response2.data.id !== undefined) {
      // Add subscription ID to DB.
      const data3 = {
        userId: cData.userId,
        fusebillSubscriptionId: response2.data.id,
      };
      await axios.post(
        `${Api}api/business/updateFusebillCustomerIdByUserId`,
        data3
      );
      // Set payment status paid.
      const data2 = {
        userId: cData.userId,
        paymentStatus: 'paid',
      };
      await axios.post(`${Api}api/user/updateUserPaymentStatus`, data2);
    }
    await localStorage.setItem(
      'fusebillCustomerId',
      response.data.result.fusebillCustomerId
    );
    await localStorage.setItem(
      'fusebillCardId',
      response.data.result.fusebillCardId
    );
    await localStorage.setItem("fusebillSubscriptionId", response1.data.id);
    =====================================================================
    */
    return {
      fusebillCustomerId: response.data.result.fusebillCustomerId,
      fusebillCardId: response.data.result.fusebillCardId,
      //fusebillSubscriptionId: response1.data.id
    };
  } catch (e) {
    return { code: 400 };
  }
};

export const fusebillCancelSubscription = async (subscriptionId) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };

    const data = {
      subscriptionId,
      cancellationOption: 'None',
    };

    const response = await axios.post(
      `${fusebillApiUrl}subscriptionCancellation`,
      data,
      config
    );
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const fusebillCountriesDataForCard = async () => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${fusebillKey}`,
      },
    };

    const response = await axios.get(`${fusebillApiUrl}Countries`, config);
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const getResourceSectionsAndLinksApi = async (param) => {
  try {
    const data = { partnerId: param };
    const response = await axios.post(
      `${Api}api/affiliate/getResourceSectionsAndLinks`,
      data
    );
    return response;
  } catch (e) {
    return { code: 400 };
  }
};

export const getDebitWalletBalanceApi = async (info) => {
  try {
    const data = {
      userId: info.userId,
      debitedAmount: info.debitedAmount,
      transferMode: info.transferMode
    };
    const response = await axios.post(
      `${Api}api/user/debitWalletBalance`,
      data
    );
    return response.data;
  } catch (e) {
    return [];
  }
};
export const getAffiliateGroupApi = async (param) => {
  try {
    const data = {     "parentPartnerId": param.parentPartnerId,"groupId" : param.groupId }
    const response = await axios.post(
      `${Api}api/affiliate/getAffiliateGroup`,
      data
    );
    return response;
  } catch (e) {
    return { code: 400 };
  }
};
